var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1923 2.90039H4.13623V21.1H20.1923V13.5429L18.0689 17.2207L18.0604 17.2159L14.2212 19.8932L14.6206 15.2299L14.6108 15.2242L20.1923 5.55691V2.90039Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4761 9.40545V7.8673H10.4596V9.40545H14.4761Z",
    fill: "#A1A3A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90767 7.86734V6.32918H7.36951V7.86734H8.90767Z",
    fill: "#A1A3A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4761 6.33015V4.79199H10.4596V6.33015H14.4761Z",
    fill: "#A1A3A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4312 9.43298H8.893V13.4495H10.4312V9.43298Z",
    fill: "#A1A3A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35579 9.43298H5.81763V13.4495H7.35579V9.43298Z",
    fill: "#A1A3A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9946 18.5541L15.1826 16.3594L16.8015 17.294L14.9946 18.5541Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1504 7.01953L22.4436 8.34352L17.8201 16.3516L15.5269 15.0276L20.1504 7.01953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.cfc7cf18d9bbfec9e02d64a99308bc1f.svg";
export { ForwardRef as ReactComponent };